module.exports = __webpack_public_path__ + "img/Vermutete_Gefahr_durch_Mineralöl.1baed5c2.svg";